import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogRef } from '../../../core/dialog/dialog-ref';
import { DialogConfig } from '../../../core/dialog/dialog.service';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
  templateUrl: './confirm-dialog.component.html',
})
export class ConfirmDialogComponent {
  dialogTitle: string;
  dialogMessage: string;

  pinControl = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(4),
    Validators.maxLength(4),
  ]);

  constructor(
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    private t: TranslateService
  ) {
    const config = this.dialogConfig;

    this.dialogTitle =
      (config.data && config.data.title) || this.t.instant('areYouSure');

    this.dialogMessage =
      (config.data && config.data.message) ||
      this.t.instant('notAbleToUndoThisAction');
  }

  close() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close({ confirmed: true });
  }
}
